import type { Theme } from "./types";

export const GALAXY_FONT: Theme["font"] = {
  sans: {
    family:
      '"ABC Diatype", Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    weight: {
      regular: 400,
      medium: 500,
    },
    size: {
      caption: "10px",
      body_sm: "12px",
      body_md: "13px",
      body_lg: "14px",
      heading_sm: "16px",
      heading_md: "20px",
      heading_lg: "24px",
    },
    height: {
      caption: "12px",
      body_sm: "14px",
      body_md: "15px",
      body_lg: "16px",
      heading_sm: "18px",
      heading_md: "22px",
      heading_lg: "26px",
    },
    spacing: {
      caption: "0.1px",
      body_sm: "0.12px",
      body_md: "0.13px",
      body_lg: "0.14px",
      heading_sm: "0.16px",
      heading_md: "0.20px",
      heading_lg: "0.24px",
    },
  },
  mono: {
    family:
      '"Berkeley Mono", ui-monospace, "SFMono-Regular", Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
    weight: {
      regular: 400,
      medium: 500,
    },
    size: {
      caption: "10px",
      body_sm: "11px",
      body_md: "12px",
      body_lg: "13px",
      heading_sm: "15px",
      heading_md: "18px",
      heading_lg: "21px",
    },
    height: {
      caption: "12px",
      body_sm: "13px",
      body_md: "15px",
      body_lg: "16px",
      heading_sm: "17px",
      heading_md: "20px",
      heading_lg: "23px",
    },
    spacing: {
      caption: "0.1px",
      body_sm: "0.12px",
      body_md: "0.13px",
      body_lg: "0.14px",
      heading_sm: "0.16px",
      heading_md: "0.20px",
      heading_lg: "0.24px",
    },
  },
};
